import { useState, useEffect } from 'react';
import { db } from '../firebase'; // Ensure Firestore is initialized in firebase.js
import { collection, addDoc, query, where, orderBy, onSnapshot } from 'firebase/firestore';
import { useAuth } from '../contexts/AuthContext';
import { Link } from 'react-router-dom';

export default function Comments({ sectionId, commentsPrompt }) {
  const { currentUser } = useAuth();
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState('');

  useEffect(() => {
    // Fetch comments for the specific section from Firestore
    const q = query(
      collection(db, 'comments'),
      where('sectionId', '==', sectionId),
      orderBy('timestamp', 'desc')
    );
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const fetchedComments = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setComments(fetchedComments);
    });

    return unsubscribe;
  }, [sectionId]);

  const handleAddComment = async () => {
    if (!newComment.trim()) return;

    try {
      await addDoc(collection(db, 'comments'), {
        text: newComment,
        userId: currentUser.uid,
        userName: currentUser.displayName || 'Anonymous',
        timestamp: new Date(),
        sectionId, // Add the sectionId field
      });
      setNewComment(''); // Clear input after adding
    } catch (error) {
      console.error('Error adding comment:', error);
    }
  };

  return (
    <div className="comments-section">
      <h4>{commentsPrompt}</h4>
      <small>Recuerda mantener una conversación en respeto</small>
      {currentUser ? (
        <div className="add-comment">
          <textarea
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
            placeholder="Deja tu comentario aquí..."
            className="form-control mb-2"
            style={{ height: '150px' }}
          />
          <button onClick={handleAddComment} className="btn btn-dark float-end Galindo">
            Enviar comentario
          </button>
        </div>
      ) : (
        <div className="login-prompt d-flex align-items-center mt-3">
          <Link to="/login" className="d-flex align-items-center text-decoration-none text-reset">
            <img
              src="https://www.diadelavida.com/images/layout/login.png"
              alt="Ingresar"
              className="login-image me-3"
            />
            <p className="mb-0">¡Haz clic aquí para ingresar y dejar comentarios!</p>
          </Link>
        </div>
      )}


      <div className='mt-5 mb-5'>
        {comments.length > 0 ? (
          <>
            <h4>Lo que otros lectores opinan</h4>
            {comments.map((comment) => (
              <div className="comment-container" key={comment.id}>
                <div className="comment">
                  <strong>{comment.userName}:</strong>
                  <div className='comment-text Amatic'>"{comment.text.trim()}"</div>
                  <div className="comment-date">
                    <small>
                      {new Date(comment.timestamp?.seconds * 1000).toLocaleString('es-ES', {
                        day: '2-digit',
                        month: 'long',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                      })}
                    </small>
                  </div>
                </div>
              </div>
            ))}
          </>
        ) : (
          <h4>¡El primer comentario es tuyo!</h4>
        )}
      </div>
    </div>
  );
}